// removed by extract-text-webpack-plugin
module.exports = {"a_button":"UploadButton__a_button___16aF4","outerMargin":"UploadButton__outerMargin___1spLv","noMargin":"UploadButton__noMargin___102jZ","noMarginMobile":"UploadButton__noMarginMobile___1e3ox","isLight":"UploadButton__isLight___1N_7S","margin":"UploadButton__margin___3RJkS","isPrimeLight":"UploadButton__isPrimeLight___3CJxg","isDark":"UploadButton__isDark___3d8Nw","isLink":"UploadButton__isLink___y-vps","isMultiline":"UploadButton__isMultiline___1Fuc8","uploadWrapper":"UploadButton__uploadWrapper___3o-EU","centerer":"UploadButton__centerer___2jOjF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/UploadButton/UploadButton.scss
// module id = 615
// module chunks = 0